// extracted by mini-css-extract-plugin
export var actionButton = "_d8-0";
export var attachmentLine = "_d8-1";
export var fileInput = "_d8-2";
export var fileUploadWrapper = "_d8-4";
export var footer = "_d8-3";
export var modalContent = "_d8-5";
export var paperclip = "_d8-6";
export var quillEditor = "_d8-7";